
import styles from './Button.module.css'

type ButtonProps = {
  name?: string
  label: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  colour?: 'blue' | 'green'
  formNoValidate?: boolean
  submit?: boolean
  loading?: boolean
}

function Button(props: ButtonProps) {
  const isLoading = props.loading ?? false

  return (
    <button
      name={props.name}
      type={props.submit ? 'submit' : 'button'}
      formNoValidate={props.formNoValidate ?? false}
      className={`${styles.button} ${styles[props.colour ?? 'grey']} ${isLoading ? styles.loading : ''}`}
      onClick={props.onClick}
      disabled={props.disabled || isLoading}
    >
      {isLoading ? (
        <>
          <span className={styles.btnSpinner} />
          Please wait...
        </>
      ) : (
        props.label
      )}
    </button>
  )
}

export { Button }
